import axios from 'axios';

export const getVisitorId = (): any => axios.get('v1/ids');